import { GalaxyFilterInterface } from './interface';

export function encodeFilters(filters: GalaxyFilterInterface[]): string {
  return encodeURIComponent(JSON.stringify(filters));
}

export function decodeFilters(filters: string): GalaxyFilterInterface[] {
  return JSON.parse(decodeURIComponent(filters));
}

export function validateFilters(filters: GalaxyFilterInterface[]): boolean {
  for (const filter of filters) {
    if (!filter.fieldId && !filter.filterId) {
      return false;
    }
    if (!filter.operator) {
      return false;
    }
  }
  return true;
}
